function hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}

const  getCmp = () => {
    if (hasProperty(window, '__cmp') === false || typeof window.__cmp !== "function") {
        return null;
    }

    return window.__cmp;
}
export default  getCmp;